var exports = {
  "u": "NativeDragRegion.module__nativeDragRegion___d19RZF",
};

module.exports = exports;
